import React from 'react';
import { Link } from 'react-router';
import { permissioned } from '../common/permissionedHoc';

const SideMenuSubItem = (props) => {
    return (
        <li role="presentation" className="has-submenu" >
            <Link to={props.subMenuItem.route.path} activeClassName="active-sidebar-item">
                <i className="fa fa-circle"> </i> <span>{props.subMenuItem.title}</span>
            </Link>
        </li>

    )
};


export default permissioned(SideMenuSubItem);



// WEBPACK FOOTER //
// ./src/components/side-menu/sideMenuSubItem.js